// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Tesamorelin Initial (systemic) 09.17.26" (050113f6-1c52-4b0b-b93f-69948293e9ac). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiTesamorelinInitialSystemicQuestions = [
  {
    field: 'mdiTesamorelinInitialSystemic_symptoms',
    label: 'Do you have any of the following symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fatigue', value: 'Fatigue' },
        { key: 'muscle_mass_reduced', value: 'Muscle Mass Reduced' },
        { key: 'low_endurance', value: 'Low Endurance' },
        { key: 'muscle_weakness', value: 'Muscle Weakness' },
        { key: 'weight_gain', value: 'Weight Gain' },
        { key: 'sleeping_difficulties', value: 'Sleeping Difficulties' },
        { key: 'low_energy', value: 'Low Energy' },
        { key: 'chronic_fatigue', value: 'Chronic Fatigue' },
        { key: 'brain_fog', value: 'Brain Fog' },
        { key: 'lack_of_focus', value: 'Lack of Focus' },
        { key: 'low_libido', value: 'Low libido' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '4a578a88-71d9-4b61-bac7-9af0b3b63714' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_injuriesSurgeriesWithinLast6',
    label: 'Have you had any injuries or surgeries within the last 6 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '4c8bf2d0-17c8-4290-b0c7-7a5f98c6ee5b' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_describeSurgeryInjuryApproximateDate',
    label: 'Please describe the surgery or injury and approximate date.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiTesamorelinInitialSystemic_describeSurgeryInjuryApproximateDate'
    },
    extras: { mdiQuestionId: '59d3f8e8-fabf-4673-a5a3-54ecc0cba934' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_apply',
    label: 'Do any of the following apply to you?',
    type: 'select',
    educationalSlide:
      '• If you have hypothyroidism, this should be controlled prior to starting Tesamorelin\n• If you have a current or previous Glioma, you are not eligible for Tesamorelin as your unique condition poses a safety risk\n• If you have any type of cancer currently, or in remission, you have a unique risk that is not present in those without cancer; you should not take Tesamorelin',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hypothyroidism', value: 'Hypothyroidism' },
        { key: 'glioma', value: 'Glioma' },
        {
          key: 'any_other_type_of_cancer_or_tumor',
          value: 'Any other type of cancer or tumor'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'a8655686-60ea-41df-89ae-21f59d0f5ba8' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_imSorryDueMedicalConditions',
    label:
      "I'm sorry, due to your medical conditions, it is not safe for you to take Tesamorelin",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '6f209ef8-3d2e-4ba5-b5f4-cf299d3202a6',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_takeMedications',
    label: 'Do you take any of the following medications?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'clonidine_or_levodopa', value: 'Clonidine or Levodopa' },
        {
          key: 'octreotide_lanreotide_or_pasireotide',
          value: 'Octreotide, lanreotide, or pasireotide'
        },
        {
          key: 'glucocorticoids_such_as_prednisone_dexam',
          value: 'Glucocorticoids (such as prednisone, dexamethasone)'
        },
        {
          key: 'cox_inhibitors_aspirin_advil_celebrex_or',
          value: 'COX inhibitors (Aspirin, Advil, Celebrex, or similar)'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '28a7844a-6b74-403a-946a-34464f0abb0c' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentMedications',
    label:
      "I'm sorry, due to your current medications, you are not an ideal candidate for Tesamorelin.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'ab862026-4664-46fb-a7f4-36af2b781ed4',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_apply2',
    label: 'Please select all that apply',
    type: 'select',
    educationalSlide:
      'This question is required to evaluate the safety of your prescription.&#160;Your answers are confidential and protected by federal law under HIPAA. We cannot and do not disclose any information from your answers.&#160;',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'i_binge_drink_4_or_more_alcoholic_drinks',
          value: 'I binge drink (4 or more alcoholic drinks at one time)'
        },
        {
          key: 'i_take_opiates_prescription_or_recreatio',
          value: 'I take opiates (prescription or recreational)'
        },
        { key: 'both_apply_to_me', value: 'Both apply to me' },
        {
          key: 'none_of_this_applies_to_me',
          value: 'NONE of this applies to me'
        }
      ]
    },
    required: false,
    extras: { mdiQuestionId: 'f527fd62-5abd-497a-800b-9811e076fdc9' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentAlcohol',
    label:
      "I'm sorry, due to your current alcohol or opiate intake, you are not an ideal candidate for Tesamorelin.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'ab957370-925e-46ef-ab35-8b0a31519813',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_lastTimePersonMedicalEvaluation',
    label:
      'When was the last time you had an in person medical evaluation including laboratory tests?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_to_2_years_ago', value: '1 to 2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: 'b6cfbc50-7eb8-4172-80df-4a659a404b74' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Please introduce yourself and give any other information about yourself and your health that you would like to.',
    answer: {
      type: 'text',
      name: 'mdiTesamorelinInitialSystemic_firstMessageDoctor',
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise health and excited to get started."'
    },
    extras: { mdiQuestionId: '9443a06b-af74-410d-81b2-97a97e7a02fb' }
  },
  {
    field: 'mdiTesamorelinInitialSystemic_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiTesamorelinInitialSystemicAnswerField = Partial<
  QuestionAnswerMap<typeof mdiTesamorelinInitialSystemicQuestions>
>;

export default mdiTesamorelinInitialSystemicQuestions;
